import { Box, Container, Stack } from "@mui/material";
import { CartButton } from "../cart-button";
import { Logo } from "./logo";
import { Menu } from "./menu";
import { MenuButton } from "./menu-button";
import { StickyHeader } from "./sticky-header";
import { TranslationContext } from "../../translation";
import React from "react";
export const MobileNavigation = ({ logo, menuItems }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => setIsOpen(!isOpen);
    const { useCart } = React.useContext(TranslationContext);
    return (React.createElement("header", { role: "menubar" },
        React.createElement(Container, { "data-testid": "mobile-navigation-container", sx: { position: "absolute", top: 0, left: 0, width: "100%", pb: 1, pt: 2, zIndex: 30 } },
            React.createElement(Stack, { direction: "row", justifyContent: "space-between" },
                useCart ? React.createElement(CartButton, { size: "small" }) : React.createElement("div", null),
                React.createElement(MenuButton, { onClick: toggleDrawer })),
            React.createElement(Box, { sx: { display: "flex", justifyContent: "center" } },
                React.createElement(Logo, { logo: logo, isSticky: false }))),
        React.createElement(StickyHeader, { "data-testid": "mobile-navigation-sticky", logo: logo, toggleMenu: toggleDrawer }),
        React.createElement(Menu, { isOpen: isOpen, items: menuItems, logo: logo, toggle: toggleDrawer })));
};
//# sourceMappingURL=mobile-navigation.js.map